import { useState, useEffect } from "react";
import { useField, useFormikContext } from "formik";
import { CONSTANT } from "../../../constant/Constant";

const FormikAudioInput = ({
  name,
  accept = ".mp3,audio/mpeg",
  className = "",
}) => {
  const { setFieldValue } = useFormikContext();
  const [, meta] = useField(name);
  const [audioURL, setAudioURL] = useState(null);

  // Update the preview URL when the file changes
  useEffect(() => {
    if (!meta.value) {
      setAudioURL(null);
      return;
    }

    // If it's a string (already uploaded), use it directly
    if (typeof meta.value === "string") {
      setAudioURL(`${CONSTANT.UI_URL}music/${meta.value}`);
      return;
    }

    // If it's a File object, create a URL
    const fileURL = URL.createObjectURL(meta.value);
    setAudioURL(fileURL);

    return () => URL.revokeObjectURL(fileURL);
  }, [meta.value]);

  return (
    <div className="w-full space-y-2">
      <input
        id={name}
        name={name}
        type="file"
        accept={accept}
        onChange={(event) => {
          const file = event.currentTarget.files[0];
          if (file) {
            setFieldValue(name, file);
          }
        }}
        className={`w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary ${className}`}
      />

      {/* Error Message */}
      {meta.touched && meta.error && (
        <div className="text-danger text-sm">{meta.error}</div>
      )}

      {/* Audio Preview */}
      {audioURL && (
        <audio key={audioURL} controls className="mt-2 w-full">
          <source src={audioURL} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      )}
    </div>
  );
};

export default FormikAudioInput;
